export const TOGGLE_STATUSBOARD = 'TOGGLE_STATUSBOARD';
export const TOGGLE_SHIFTPERFORMANCEBOARD = 'TOGGLE_SHIFTPERFORMANCEBOARD';
export const TOGGLE_OEEBOARD = 'TOGGLE_OEEBOARD';
export const TOGGLE_PROGRESSIONBOARD = 'TOGGLE_PROGRESSIONBOARD';
export const TOGGLE_MESSAGESBOARD = 'TOGGLE_MESSAGESBOARD';
export const SET_DASHBOARDCONFIGURATIONDRAWEROPEN = 'SET_DASHBOARDCONFIGURATIONDRAWEROPEN';
export const SET_TIMERS = 'SET_TIMERS';
export const SET_PROGRESSIONS = 'SET_PROGRESSIONS';





